export const calculate = (seconds) => {
    const h = Math.floor(seconds / 3600).toString().padStart(2,'0'),
          m = Math.floor(seconds % 3600 / 60).toString().padStart(2,'0'),
          s = Math.floor(seconds % 60).toString().padStart(2,'0');
    if(h==0)
        return m + ':' + s;
    else
        return h + ':' + m + ':' + s;
}